import { DEFAULT_HEARTBEAT_INTERVAL, HEARTBEAT_INTERVALS } from '../constants';

// check if locator is not reporting
// locator last heartbeat > 3 times the heartbeat interval
function isLocatorNotReporting(locator) {
  if (!locator) {
    return false;
  }
  const locatorData = locator.data || locator.data?.data;
  const effectiveHeartbeatInterval = locatorData?.effectiveHeartbeatInterval ?? DEFAULT_HEARTBEAT_INTERVAL; // default to 2 hours
  const lastHeartbeat = locatorData?.lastHeartbeat ?? 0;
  const now = Date.now();
  return now - lastHeartbeat > effectiveHeartbeatInterval * 3 * 1000;
}
function notReportingLocatorsFilter() {
  // check if a locator has any of the matching heartbeat intervals, and if its last heartbeat is older than 3 of those intervals
  const heartbeatIntervalSearchConditions = HEARTBEAT_INTERVALS.map(interval => {
    return {
      type: 'logical',
      operator: 'and',
      conditions: [{
        type: 'equals',
        field: 'data/effectiveHeartbeatInterval',
        value: interval
      }, {
        type: 'comparison',
        field: 'data/lastHeartbeat',
        value: `now-${3 * interval}s`,
        comparator: '<=',
        isDate: true
      }]
    };
  });

  // if a locator has no heartbeat interval, default it to 2 hours and check that
  const defaultHeartbeatIntervalSearchCondition = {
    type: 'logical',
    operator: 'and',
    conditions: [{
      type: 'exists',
      field: 'data/effectiveHeartbeatInterval',
      not: true
    }, {
      type: 'comparison',
      field: 'data/lastHeartbeat',
      value: `now-${3 * DEFAULT_HEARTBEAT_INTERVAL}s`,
      comparator: '<=',
      isDate: true
    }]
  };
  return {
    type: 'logical',
    operator: 'or',
    conditions: [defaultHeartbeatIntervalSearchCondition, {
      type: 'logical',
      operator: 'or',
      conditions: heartbeatIntervalSearchConditions
    }]
  };
}

// similar to locators filter above, but for vehicles
function notReportingVehicleLocatorsFilter() {
  // check if a locator has any of the matching heartbeat intervals, and if its last heartbeat is older than 3 of those intervals
  const heartbeatIntervalSearchConditions = HEARTBEAT_INTERVALS.map(interval => {
    return {
      type: 'logical',
      operator: 'and',
      conditions: [{
        type: 'equals',
        field: 'data/locator/data/effectiveHeartbeatInterval',
        value: interval
      }, {
        type: 'comparison',
        field: 'data/locator/data/lastHeartbeat',
        value: `now-${3 * interval}s`,
        comparator: '<=',
        isDate: true
      }]
    };
  });

  // if a locator has no heartbeat interval, default it to 2 hours and check that
  const defaultHeartbeatIntervalSearchCondition = {
    type: 'logical',
    operator: 'and',
    conditions: [{
      type: 'exists',
      field: 'data/locator/data/effectiveHeartbeatInterval',
      not: true
    }, {
      type: 'comparison',
      field: 'data/locator/data/lastHeartbeat',
      value: `now-${3 * DEFAULT_HEARTBEAT_INTERVAL}s`,
      comparator: '<=',
      isDate: true
    }]
  };
  return {
    type: 'logical',
    operator: 'or',
    conditions: [defaultHeartbeatIntervalSearchCondition, {
      type: 'logical',
      operator: 'or',
      conditions: heartbeatIntervalSearchConditions
    }]
  };
}
export default {
  isLocatorNotReporting,
  notReportingLocatorsFilter,
  notReportingVehicleLocatorsFilter
};